
export class MaintenanceRoutineHomologousModel {
  maintenanceRoutineHomologousId: number = 0;
  maintenanceRoutineId: number = 0;
  articleId: number = 0;
  mainArticleId: number = 0;
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}